import { useQuery } from "@tanstack/react-query";
import { type Address } from "viem";

import { MORPHO_CADC_USDC_MARKET_ID, VENUES } from "@/config/contracts";
import { MORPHO_BLUE_ABI } from "@/config/morpho-abi";
import { buildPublicClient } from "@/lib/wallet/clients";

export type MorphoPosition = {
  readonly supplyShares: bigint;
  readonly borrowShares: bigint;
  readonly collateral: bigint;
};

export const useMorphoPosition = (account: Address | undefined) =>
  useQuery({
    queryKey: ["morpho-position", MORPHO_CADC_USDC_MARKET_ID, account],
    enabled: Boolean(account),
    queryFn: async (): Promise<MorphoPosition> => {
      const client = buildPublicClient();
      const tuple = await client.readContract({
        address: VENUES.morpho.contract,
        abi: MORPHO_BLUE_ABI,
        functionName: "position",
        args: [MORPHO_CADC_USDC_MARKET_ID, account as Address],
      });
      return {
        supplyShares: tuple[0],
        borrowShares: tuple[1],
        collateral: tuple[2],
      };
    },
  });
